import type { SVGProps } from 'react'
const SvgSyArrowLeftSquare = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M7.916 2c-1.67 0-3.158.527-4.228 1.523S2 5.975 2 7.666v8.67c0 1.687.616 3.14 1.686 4.137S6.246 22 7.916 22h8.168c1.67 0 3.158-.525 4.229-1.521 1.07-.997 1.687-2.452 1.687-4.143v-8.67c0-1.691-.617-3.146-1.687-4.143S17.753 2 16.084 2zm0 1.5h8.168c1.358 0 2.45.417 3.207 1.121S20.5 6.328 20.5 7.666v8.67c0 1.338-.453 2.339-1.209 3.043s-1.85 1.121-3.207 1.121H7.916c-1.357 0-2.45-.418-3.207-1.123S3.5 17.669 3.5 16.336v-8.67c0-1.338.453-2.34 1.209-3.045.756-.704 1.85-1.121 3.207-1.121"
				clipRule="evenodd"
				opacity={0.4}
			/>
			<path d="M7.914 11.25a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h8.172a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z" />
			<path d="M11.68 7.502a.75.75 0 0 0-.532.219l-3.763 3.748a.75.75 0 0 0 0 1.062l3.763 3.748a.75.75 0 0 0 1.061-.002.75.75 0 0 0-.002-1.06L8.977 12l3.23-3.217a.75.75 0 0 0 .002-1.06.75.75 0 0 0-.53-.221" />
		</g>
	</svg>
)
export default SvgSyArrowLeftSquare
